import ResidentStatusFlagsScreen from "app/screens/residents/status-flags/ResidentStatusFlagsScreen";

export default function ResidentStatusFlagPage() {
  return <ResidentStatusFlagsScreen />;
}
